<template>
  <hm-content title="">
    <div class="flex flex-between">
      <div class="flex flex-wrap">
        <div class=" bd">
          <div class="my-report report-w">
            我的报表
          </div>
          <el-scrollbar style="height:100%" class="page-component__scroll">
            <div style="margin-bottom:50px">
              <div
                v-for="(v, i) in lv1List"
                :key="i"
                class=" pointer"
                @click="active(v)"
              >
                <div
                  class="body-report flex flex-between report-w"
                  :class="{
                    'is-active': v.key === isCollapse
                  }"
                >
                  <span> {{ v.title }}</span>

                  <i class="el-icon-arrow-right icon-style"></i>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div
          class="bd"
          v-for="(lv1List, k) in myReportList"
          :key="k"
          v-if="myReportList.length"
        >
          <div
            class="my-report report-w"
            style="color:#222;background:#fff;fontWeight:bold;marginTop:50px"
          >
            {{ lv1List[0].title }}({{ lv1List.length - 1 }})
          </div>
          <el-scrollbar class="page-component__scroll">
            <div style="margin-bottom:100px">
              <div
                v-for="(v, i) in lv1List"
                :key="i"
                class="pointer"
                @click="childActive(v, k, i)"
              >
                <!-- <div
                v-if="i === 0"
                class="my-report report-w"
                style="color:#222;background:#fff;fontWeight:bold"
              >
                {{ v.title }}({{ lv1List.length - 1 }})
              </div> -->

                <div
                  v-if="i !== 0"
                  class="body-report flex flex-between report-w"
                  :class="{
                    'is-child-active': v.isChild,
                    'is-active': v.isParent
                  }"
                >
                  <span> {{ v.title }}</span>
                  <i
                    class="el-icon-arrow-right icon-style"
                    v-if="v.parentId"
                  ></i>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="flex-1 report-remark">
        <div v-if="row.id">
          <div class="title">
            说明
          </div>
          {{ row.remark }}
          <div style="marginTop:30px" class="flex flex-center">
            <el-button size="small" type="primary" @click="details(row)"
              >去分析</el-button
            >
          </div>
        </div>
        <div v-else class="flex-1">
          <img
            style="width:100%"
            src="https://imgcdn.hemiao100.com/ThemePictures/report-bg.png"
            alt="xx"
          />
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      lv1List: [
        {
          title: "最近使用报表",
          key: "queryRecentUsageList"
        },
        {
          title: "我的收藏",
          key: "queryFavoriteList"
        }
      ],
      myReportList: [],
      activeName: "second",
      content: 123,
      isCollapse: "",
      isChild: "",
      activeIndex: "",
      searchCondition: {},
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      sysCategoryId: "",
      row: {},
      parentRow: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.queryList();
    this.queryTree();
  },
  methods: {
    active(v) {
      this.isCollapse = v.key;
      this.myReportList = [];
      this.row = {};
      this.parentRow = v;
      this.sysCategoryId = v.key;
      if (v.children) {
        v.children.forEach(v => {
          v.isParent = false;
          v.isChild = false;
        });
        this.myReportList.push(v.children);
        this.myReportList[0].unshift(v);

        // let params = {
        //   pageNo: 1,
        //   pageSize: 9999,
        //   sysCategoryId: this.sysCategoryId
        // };

        // this.$store.dispatch("queryUsePageList", params).then(res => {
        //   const { records } = res.result;
        //   if (records.length) {
        //     records.forEach(v => {
        //       v.title = v.reportName;
        //       v.show = true;
        //     });

        //     this.myReportList[0].push(...records);
        //   }
        // });
        this.queryList(0);
        this.myReportList[0] = arrayUnique2(this.myReportList[0], "key");
      } else {
        if (v.key === "queryRecentUsageList" || v.key === "queryFavoriteList") {
          this.queryFavoriteList(v.key);
        } else {
          this.queryList();
        }
      }

      this.$forceUpdate();
    },
    async queryFavoriteList(name) {
      const { result } = await this.$store.dispatch(name);
      if (result.length) {
        result.forEach(v => {
          v.title = v.reportName;
          v.show = true;
        });
        this.myReportList.push(result);
        this.myReportList[this.myReportList.length - 1].unshift(this.parentRow);
        this.defaultSelect();
      }
    },
    childActive(v, k, i) {
      if (i !== 0) {
        this.myReportList[k].forEach(v => {
          v.isParent = false;
          v.isChild = false;
        });

        v.isParent = true;
        if (v.show) {
          this.myReportList.splice(k + 1, this.myReportList.length);
          this.row = v;
          v.isChild = true;
        } else {
          if (v.children) {
            v.isParent = true;
          } else {
            this.sysCategoryId = v.key;
            this.row = {};
            this.queryList();
            // v.isChild = true;
          }
          this.parentRow = v;
        }

        this.$forceUpdate();
      }
    },
    handleSelect(key) {
      this.sysCategoryId = key;
      this.queryList();
    },

    async queryTree() {
      let params = {
        pcode: "B03",
        async: false
      };
      const { result } = await this.$store.dispatch("loadTreeRoot", params);
      this.menuList = result;
      this.lv1List.push(...this.menuList);
    },

    details(row) {
      console.log("row: ", row);
      if (row.reportType !== "template") {
        this.$router.push({
          name: "CustomReportAnalyze",
          query: {
            id: row.id,
            reportName: row.reportName
          }
        });
      } else {
        this.$router.push({
          name: "CustomReportAnalyzes",
          query: {
            id: row.id,
            reportName: row.reportName
          }
        });
      }
    },
    async queryList(i) {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        sysCategoryId: this.sysCategoryId
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryUsePageList", params);
      const { records, total } = result;
      this.list = records;
      if (records.length) {
        records.forEach(v => {
          v.title = v.reportName;
          v.show = true;
        });
        if (i === 0) {
          this.myReportList[0].push(...records);

          this.$forceUpdate();
        } else {
          this.myReportList.push(records);
          this.myReportList[this.myReportList.length - 1].unshift(
            this.parentRow
          );
        }
        this.defaultSelect();
      }
      this.total = total;
    },
    defaultSelect() {
      this.myReportList[0][1].isChild = true;
      this.myReportList[0][1].isParent = true;
      this.row = this.myReportList[0][1];
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
.menu-container {
  .reports {
    .el-menu {
      // height: calc(100vh - 200px) !important;
      .el-submenu {
        overflow: hidden;
        & > .el-submenu__title {
          padding-left: none !important;

          .el-submenu__icon-arrow {
            display: block !important;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: #222;
  font-weight: bold;
  margin-bottom: 20px;
  // &::before {
  //   display: inline-block;
  //   margin-right: 5px;
  //   content: "";
  //   width: 5px;
  //   height: 13px;
  //   background: #e50065;
  //   border-top-left-radius: 30px;
  //   border-bottom-right-radius: 30px;
  // }
}
.icon-style {
  line-height: 50px;
  color: #bfcbd9;
  font-size: 12px;
}
.report-w {
  min-width: 140px;

  height: 50px;
  line-height: 50px;
}
.my-report {
  font-size: 16px;
  background: #e50065;
  color: #ffffff;
  padding-left: 10px;
}
.report-remark {
  padding: 30px 30px 0 50px;
}
.bd {
  border-right: 1px solid #eeeeee;
  height: calc(100vh - 200px);
}
.body-report {
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  text-align: left;
}
.is-active {
  color: #e50065;
}
.is-child-active {
  color: #e50065;
  background: #fedeec;
}
</style>
